// extracted by mini-css-extract-plugin
export default {"root":"ProgressBar_root__ntY1R","progress":"ProgressBar_progress__7IZkF","counter":"ProgressBar_counter__Wvaat"};